(ns dashboard.components.attachment-picker
  "Note that this namespace is probably deprecated"
  (:require [dashboard.common :refer [format-date-time]]
            [dashboard.components.confirm-delete-attachment-modal :refer [confirm-delete-attachment-modal]]
            [dashboard.components.paginated-list.view :refer [paginated-list]]
            [dashboard.entity.questionnaire.db :as questionnaire.db]
            [dashboard.services.document-viewer :as doc-viewer]
            [dashboard.services.documents :as documents]
            [dashboard.ui :as ui]
            [dashboard.views.policy.subs :as policy-subs]
            [dashboard.views.policy.view :as policy-view]
            [re-frame.core :as rf]))

(defn make-policy-column-config [source questionnaire-id attachments answer-id question-id linked-attachments]
  [{:label    "Filename"
    :id       :filename
    :sort-key :filename
    :render   (fn [{:keys [id filename]}]
                (let [{:keys [attaching detaching?]} @(rf/subscribe [::policy-subs/policy-status id])]
                  [:a {:class    (when (or attaching detaching?) "has-text-light")
                       :href     "#"
                       :on-click #(rf/dispatch [::doc-viewer/fetch-file-preview-url filename id])
                       :title    "Preview document"}
                 filename]))}
   {:label    "Created"
    :id       :created
    :sort-key :created
    :render   (fn [{:keys [id created]}]
                (let [{:keys [attaching detaching?]} @(rf/subscribe [::policy-subs/policy-status id])]
                  [:span {:class (when (or attaching detaching?) "has-text-light")} (format-date-time created)]))
    :classes  ["is-narrow"]}
   {:label   ""
    :id      :actions
    :render  (fn [{:keys [id filename]}]
               (let [{:keys [attaching detaching?]} @(rf/subscribe [::policy-subs/policy-status id])
                     attachment-index               (->> attachments (map #(vector (:document-id %) %)) (into {}))
                     attached-policy-ids            (->> attachments (map :document-id) set)
                     linked-policy-ids              (->> linked-attachments (map :document-id) set)
                     is-linked?                     (linked-policy-ids id)
                     is-attached?                   (attached-policy-ids id)]
                 (cond
                   (not is-attached?)
                   [:button.button.is-small.is-info.is-info.is-rounded
                    {:class    (when attaching "is-loading")
                     :title    (if (= source :answer) "Link document" "Attach document")
                     :on-click #(questionnaire.db/add-attachment
                                 questionnaire-id
                                 (conj {:type "document" :document-id id :filename filename}
                                       (when answer-id
                                         {:linked-answers #{answer-id}})))}
                    [:span.icon
                     [:i.fas.fa-link]]]
                   (and (= source :answer) (not is-linked?))
                   [:button.button.is-small.is-info.is-rounded
                    {:class    (when attaching "is-loading")
                     :title    "Link document"
                     :on-click #(questionnaire.db/link-answer-to-attachment
                                 questionnaire-id
                                 answer-id
                                 question-id
                                 (attachment-index id))}
                    [:span.icon
                     [:i.fas.fa-link]]]
                   (and (= source :answer) is-linked?)
                   [:button.button.is-small.is-info.is-warning.is-rounded
                    {:class    (when attaching "is-loading")
                     :title    "Unlink document"
                     :on-click #(questionnaire.db/unlink-answer-from-attachment
                                 questionnaire-id
                                 question-id
                                 answer-id
                                 (attachment-index id))}
                    [:span.icon
                     [:i.fas.fa-link-slash]]]
                   is-attached?
                   [:button.button.is-small.is-info.is-danger.is-rounded
                    {:class    (when detaching? "is-loading")
                     :title    "Detach document"
                     :on-click (fn [_]
                                 (rf/dispatch
                                  [::ui/push-modal
                                   {:ctx       (attachment-index id)
                                    :component (confirm-delete-attachment-modal
                                                {:on-confirm #(questionnaire.db/delete-attachment
                                                               questionnaire-id (attachment-index id))})}]))}
                    [:span.icon
                     [:i.fas.fa-link-slash]]])))
    :classes ["is-narrow"]}])

(rf/reg-sub
 ::document-rows
 :<- [::documents/data]
 (fn [documents]
   (map #(assoc % :paginated-list/row-key (:id %)) documents)))

(defn attachment-picker [{{:keys [source answer-id question-id questionnaire-id]} :ctx}]
  (let [questionnaire-attachments @(questionnaire.db/questionnaire-attachments* questionnaire-id)
        linked-attachments        @(questionnaire.db/answer-attachments* answer-id)
        column-config             (make-policy-column-config source questionnaire-id
                                                             questionnaire-attachments
                                                             answer-id question-id
                                                             linked-attachments)]
    [:div.card
     [:header.card-header.has-background-secondary.is-shadowless
      [:title.card-header-title "Attach documents"]
      [:button.card-header-icon {:on-click #(rf/dispatch [::ui/pop-modal])
                                 :title "Close dialog"}
       [:span.icon [:i.fas.fa-xmark]]]]
     [:div.px-4
      [:f> paginated-list
       {:view-name      :attachment-picker/for-questionnaire
        :header-content [:a.button.is-info.mx-3.is-rounded
                         {:on-click #(rf/dispatch [::ui/push-modal {:ctx       {:source    source
                                                                               :answer-id answer-id}
                                                                   :component #'policy-view/upload-policy-modal}])
                          :title (str "Upload a new document for attaching"
                                      (case source
                                        :answer " to answer"
                                        :questionnaire " to questionnaire"
                                        ""))}
                         "Upload"]
        :columns column-config}
       {:items-sub [::document-rows]
        :loading-sub [::documents/loading]
        :default-sort-keyfn :created
        :default-sort-order :asc}]]]))
